import React from 'react'
import PropTypes from 'prop-types'

const FaceRect = props => (
  <div
    key={props.faceId}
    style={{
      color: 'white',
      fontWeight: 'bold',
      fontSize: '16px',
      border: props.label === 'Unknow' ? '3px solid #ff0000' : '3px solid #00ff00',
      position: 'absolute',
      top: props.top,
      left: props.left,
      width: props.width,
      height: props.height,
      transitionProperty: 'top, left, width, height',
      transitionDuration: '0.25s',
    }}
  >
    {props.label}
  </div>
)
FaceRect.propTypes = {
  label: PropTypes.string.isRequired,
  faceId: PropTypes.string.isRequired,
  top: PropTypes.number.isRequired,
  left: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
}

export default FaceRect



// WEBPACK FOOTER //
// ./src/components/FaceRect.js